var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27457_173793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69727 17.8227C7.69727 17.5587 8.08607 13.3971 8.08607 13.3971L10.8917 11.5635",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8887 11.5635L11.1719 15.0003L12.8111 13.5723L10.8887 11.5635Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4225 15.2139L11.7529 17.8227",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9258 17.8227C17.9258 17.5587 17.537 13.3971 17.537 13.3971L14.7314 11.5635",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7339 11.5635L14.4507 15.0003L12.8115 13.5723L14.7339 11.5635Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8121 13.5723L11.9385 14.3355L12.4233 15.2115H12.8121H13.2009L13.6857 14.3355L12.8121 13.5723Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2002 15.2139L13.8698 17.8227",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7344 16.1709H16.232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8515 8.68093C14.8515 7.29853 13.9371 6.17773 12.8115 6.17773C11.6859 6.17773 10.7715 7.29853 10.7715 8.68093C10.7715 10.0633 11.6859 11.1865 12.8115 11.1865C13.9371 11.1865 14.8515 10.0657 14.8515 8.68093Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4912 13.4353L19.3752 12.2041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6686 13.5553L19.375 12.2041",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2118 16.9322C24.2118 16.7546 23.8518 13.4402 23.8518 13.4402L21.9678 12.209",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9601 12.2041L20.6689 13.5553V16.1713",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6692 11.9498C21.4261 11.9498 22.0396 11.1965 22.0396 10.2674C22.0396 9.3382 21.4261 8.58496 20.6692 8.58496C19.9124 8.58496 19.2988 9.3382 19.2988 10.2674C19.2988 11.1965 19.9124 11.9498 20.6692 11.9498Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13205 13.4353L6.24805 12.2041",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9541 13.5553L6.2477 12.2041",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41113 16.9322C1.41113 16.7546 1.77113 13.4402 1.77113 13.4402L3.65513 12.209",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66309 12.2041L4.95429 13.5553V16.1713",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95438 11.9498C5.71124 11.9498 6.32478 11.1965 6.32478 10.2674C6.32478 9.3382 5.71124 8.58496 4.95438 8.58496C4.19753 8.58496 3.58398 9.3382 3.58398 10.2674C3.58398 11.1965 4.19753 11.9498 4.95438 11.9498Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27457_173793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.811523)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.5d5b8d62fa0ada8df5163021c86c9c07.svg";
export { ForwardRef as ReactComponent };